import {SODeleteView} from '../../core/view/so-delete-view';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteView extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteView;
}